import { makeStyles } from "@material-ui/core"

export const loadsListStyle = makeStyles((theme) => ({
    listWrapper: {
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        height: '61vh',
        minWidth: '1200px',
    },
    selectAllBar: {
        flexShrink: 0,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        borderBottom: '1px solid lightgrey',
        backgroundColor: theme.palette.background.paper,
    },
    listScrollArea: {
        flex: 1,
        minHeight: 0,
        '& ul': {
            height: '100% !important',
        },
    },
    listItem: {
        borderBottom: '1px solid lightgrey',
    },
    flaggedLoad: {
        backgroundColor: '#ffff0029'
    }
}));